import {Routes, Route} from 'react-router-dom';
import {IndexPage} from './pages/IndexPage';
import {CreatePage} from './pages/CreatePage';

export const ProviderMappingsLayout = () => {
    return (
        <Routes>
            <Route index element={<IndexPage />} />
            <Route path="create" element={<CreatePage />} />
        </Routes>
    );
};